import { render, staticRenderFns } from "./KeywordsBlacklist.vue?vue&type=template&id=7df62936&scoped=true"
import script from "./KeywordsBlacklist.vue?vue&type=script&lang=js"
export * from "./KeywordsBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df62936",
  null
  
)

export default component.exports